import { render, staticRenderFns } from "./PaymentProgramLevelSelectbox.vue?vue&type=template&id=70b3de95"
import script from "./PaymentProgramLevelSelectbox.vue?vue&type=script&lang=js"
export * from "./PaymentProgramLevelSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports